<ion-button
  expand="block"
  color="dark"
  fill="{{type === 'primary' ? 'solid' : 'outline'}}"
  [disabled]="disabled"
  (click)="onAction()"
  class="action-button"
>
  <ion-label>{{ label }}</ion-label>
</ion-button>